import { inject, provide, ref } from "vue";
export const MEDIA_PLAYER_CONTEXT_KEY = Symbol();
export const initMediaPlayerContext = (mediaPlayerCurrentTime, mediaPlayerIsPlaying, mediaPlayerSeekTick) => {
    provide(MEDIA_PLAYER_CONTEXT_KEY, {
        mediaPlayerCurrentTime,
        mediaPlayerIsPlaying,
        mediaPlayerSeekTick
    });
};
export const useMediaPlayerContext = () => {
    return inject(MEDIA_PLAYER_CONTEXT_KEY, {
        mediaPlayerCurrentTime: ref(0),
        mediaPlayerIsPlaying: ref(false),
        mediaPlayerSeekTick: ref(0)
    });
};
